require('./RAStrategyCards.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAStrategyItem = require('./RAStrategyItem/RAStrategyItem');

// @constants
const {
    CARD_ONE,
    CARD_TWO,
    CARD_THREE,
    CARD_FOUR,
    CARD_FIVE,
} = require('../../raConstants/index');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;

// @contactCenter
const RAStrategyCardsInfo = require('../../components/contactCenter/RAStrategyCardsInfo/RAStrategyCardsInfo');

class RAStrategyCards extends React.Component {
    buildInfo() {
        const infoContact = (
            <FormattedText
                value="raStrategyCards-raStrategyCards_contact"
                className="ra-strategy-cards__info--bold"
            />
        );

        return (
            <FormattedTextWithComponents
                value="raStrategyCards-raStrategyCards_info"
                className="ra-strategy-cards__info"
                injectedComponents={[infoContact]}
            />
        );
    }

    render() {
        const {
            selectedCard,
            selectStrategy,
            maxAvailable,
            onStrategyDetailsClick,
            firstCardSelected,
            modifyPlan,
            clientName,
        } = this.props;
        const lowRiskText = formatText('raStrategyItem-lowRisk');
        const midRiskText = formatText('raStrategyItem-midRisk');
        const highRiskText = formatText('raStrategyItem-highRisk');
        const midHighRisk = formatText('raStrategyItem-midHighRisk');
        const midLowRisk = formatText('raStrategyItem-midLowRisk');

        const info = maxAvailable < 5 ? this.buildInfo() : null;

        return (
            <div className="ra-strategy-cards">
                <div className="ra-strategy-cards__items">
                    <RAStrategyItem
                        id={CARD_ONE}
                        riskType={lowRiskText}
                        selectedCard={selectedCard}
                        selectStrategy={selectStrategy}
                        disabled={CARD_ONE > maxAvailable}
                        modifyPlan={modifyPlan}
                        firstCardSelected={firstCardSelected}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        countryLabel={formatText(
                            'raStrategyItem-raStrategyItem_1',
                        )}
                    />
                    <RAStrategyItem
                        id={CARD_TWO}
                        riskType={midLowRisk}
                        selectedCard={selectedCard}
                        selectStrategy={selectStrategy}
                        disabled={CARD_TWO > maxAvailable}
                        modifyPlan={modifyPlan}
                        firstCardSelected={firstCardSelected}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        countryLabel={formatText(
                            'raStrategyItem-raStrategyItem_2',
                        )}
                    />
                    <RAStrategyItem
                        id={CARD_THREE}
                        riskType={midRiskText}
                        selectedCard={selectedCard}
                        selectStrategy={selectStrategy}
                        disabled={CARD_THREE > maxAvailable}
                        modifyPlan={modifyPlan}
                        firstCardSelected={firstCardSelected}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        countryLabel={formatText(
                            'raStrategyItem-raStrategyItem_3',
                        )}
                    />
                    <RAStrategyItem
                        id={CARD_FOUR}
                        riskType={midHighRisk}
                        selectedCard={selectedCard}
                        selectStrategy={selectStrategy}
                        disabled={CARD_FOUR > maxAvailable}
                        modifyPlan={modifyPlan}
                        firstCardSelected={firstCardSelected}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        countryLabel={formatText(
                            'raStrategyItem-raStrategyItem_4',
                        )}
                    />
                    <RAStrategyItem
                        id={CARD_FIVE}
                        riskType={highRiskText}
                        selectedCard={selectedCard}
                        selectStrategy={selectStrategy}
                        disabled={CARD_FIVE > maxAvailable}
                        modifyPlan={modifyPlan}
                        firstCardSelected={firstCardSelected}
                        onStrategyDetailsClick={onStrategyDetailsClick}
                        countryLabel={formatText(
                            'raStrategyItem-raStrategyItem_5',
                        )}
                    />
                </div>
                <div className="ra-strategy-cards__info-wrapper">{info}</div>
                {__CONTACT_CENTER__ && (
                    <RAStrategyCardsInfo
                        selectedCard={selectedCard}
                        clientName={clientName}
                        suitableProfile={maxAvailable}
                    />
                )}
            </div>
        );
    }
}

RAStrategyCards.propTypes = {
    firstCardSelected: PropTypes.number,
    maxAvailable: PropTypes.number.isRequired,
    modifyPlan: PropTypes.bool,
    onStrategyDetailsClick: PropTypes.func,
    selectedCard: PropTypes.number.isRequired,
    selectStrategy: PropTypes.func.isRequired,
    title: PropTypes.string,
    clientName: PropTypes.string,
};

RAStrategyCards.defaultProps = {
    firstCardSelected: 0,
    modifyPlan: false,
    onStrategyDetailsClick: null,
};

module.exports = RAStrategyCards;
